const AppTemplate = {

    DPModvars : [
        { proj : 1, modID: 1, tag: "<BigPop MV3>" },
        { proj : 1, modID: 1, tag: "<TFR MV>" },
        { proj : 1, modID: 1, tag: "<ASFR MV>" },
        { proj : 1, modID: 1, tag: "<ASFRTables MV>" },
        { proj : 1, modID: 1, tag: "<ASFRNum MV>" },
        { proj : 1, modID: 1, tag: "<SexBirthRatio MV>" },
        { proj : 1, modID: 1, tag: "<LE MV2>" },
        { proj : 1, modID: 1, tag: "<MigrRate MV2>" },
        { proj : 1, modID: 1, tag: "<MigrAgeDist MV2>" },
    ],

    DPEditors : [
        { proj : 1, modID : 1, editorMstID : 1 },
        { proj : 1, modID : 1, editorMstID : 2 },
        { proj : 1, modID : 1, editorMstID : 3 },
        { proj : 1, modID : 1, editorMstID : 4 },
        { proj : 1, modID : 1, editorMstID : 5 },
        { proj : 1, modID : 1, editorMstID : 6 },
        { proj : 1, modID : 1, editorMstID : 8 },
        { proj : 1, modID : 1, editorMstID : 9 },
        { proj : 1, modID : 1, editorMstID : 71 },
        { proj : 1, modID : 1, editorMstID : 99 }, // 4 editors
        // { proj : 1, modID : 1, editorMstID : 99, model : 1 },
        // { proj : 1, modID : 1, editorMstID : 99, model : 2 },
        // { proj : 1, modID : 1, editorMstID : 99, model : 3 },
        // { proj : 1, modID : 1, editorMstID : 99, model : 4 },
    ],

    AMModvars : [

    ],

    AMEditors : [
        { proj : 1, modID : 4, editorMstID : 10 },
        { proj : 1, modID : 4, editorMstID : 11 },
        { proj : 1, modID : 4, editorMstID : 12 },
        { proj : 1, modID : 4, editorMstID : 13 },
        { proj : 1, modID : 4, editorMstID : 14 },
        { proj : 1, modID : 4, editorMstID : 15 },
        { proj : 1, modID : 4, editorMstID : 16 },
        { proj : 1, modID : 4, editorMstID : 17 },
        { proj : 1, modID : 4, editorMstID : 18 },
        { proj : 1, modID : 4, editorMstID : 19 },
        { proj : 1, modID : 4, editorMstID : 20 },
        { proj : 1, modID : 4, editorMstID : 21 },
        { proj : 1, modID : 4, editorMstID : 22 },
        { proj : 1, modID : 4, editorMstID : 23 },
        { proj : 1, modID : 4, editorMstID : 24 },
        { proj : 1, modID : 4, editorMstID : 25 },
        { proj : 1, modID : 4, editorMstID : 26 },
        { proj : 1, modID : 4, editorMstID : 27 },
        { proj : 1, modID : 4, editorMstID : 28 },
        { proj : 1, modID : 4, editorMstID : 29 },
        { proj : 1, modID : 4, editorMstID : 30 },
        { proj : 1, modID : 4, editorMstID : 31 },
        { proj : 1, modID : 4, editorMstID : 32 },
        { proj : 1, modID : 4, editorMstID : 33 },
        { proj : 1, modID : 4, editorMstID : 34 },
        { proj : 1, modID : 4, editorMstID : 35 },
        { proj : 1, modID : 4, editorMstID : 36 },
        { proj : 1, modID : 4, editorMstID : 37 },
        { proj : 1, modID : 4, editorMstID : 38 },
        { proj : 1, modID : 4, editorMstID : 39 },
        { proj : 1, modID : 4, editorMstID : 40 },
        { proj : 1, modID : 4, editorMstID : 41 },
        { proj : 1, modID : 4, editorMstID : 42 },
        { proj : 1, modID : 4, editorMstID : 43 },
        { proj : 1, modID : 4, editorMstID : 44 },
        { proj : 1, modID : 4, editorMstID : 45 },
        { proj : 1, modID : 4, editorMstID : 46 },
        { proj : 1, modID : 4, editorMstID : 47 },
        { proj : 1, modID : 4, editorMstID : 48 },
        { proj : 1, modID : 4, editorMstID : 49 },
        { proj : 1, modID : 4, editorMstID : 50 },
        { proj : 1, modID : 4, editorMstID : 51 },
        { proj : 1, modID : 4, editorMstID : 52 },
        { proj : 1, modID : 4, editorMstID : 53 },
        { proj : 1, modID : 4, editorMstID : 54 },
        { proj : 1, modID : 4, editorMstID : 55 },
        { proj : 1, modID : 4, editorMstID : 56 },
        { proj : 1, modID : 4, editorMstID : 57 },
        { proj : 1, modID : 4, editorMstID : 58 },
        { proj : 1, modID : 4, editorMstID : 59 },
        { proj : 1, modID : 4, editorMstID : 60 },
        { proj : 1, modID : 4, editorMstID : 61 },
        { proj : 1, modID : 4, editorMstID : 62 },
        { proj : 1, modID : 4, editorMstID : 63 },
        { proj : 1, modID : 4, editorMstID : 64 },
        { proj : 1, modID : 4, editorMstID : 65 },
        { proj : 1, modID : 4, editorMstID : 66 },
        { proj : 1, modID : 4, editorMstID : 67 },
        { proj : 1, modID : 4, editorMstID : 68 },
        { proj : 1, modID : 4, editorMstID : 69 },
        { proj : 1, modID : 4, editorMstID : 72 },
        { proj : 1, modID : 4, editorMstID : 73 },
        { proj : 1, modID : 4, editorMstID : 74 },
        { proj : 1, modID : 4, editorMstID : 75 },
        { proj : 1, modID : 4, editorMstID : 76 },
        { proj : 1, modID : 4, editorMstID : 77 },
        { proj : 1, modID : 4, editorMstID : 78 },
        { proj : 1, modID : 4, editorMstID : 79 },
        { proj : 1, modID : 4, editorMstID : 80 },
        { proj : 1, modID : 4, editorMstID : 81 },
        { proj : 1, modID : 4, editorMstID : 82 },
        { proj : 1, modID : 4, editorMstID : 83 },
        { proj : 1, modID : 4, editorMstID : 84 },
        { proj : 1, modID : 4, editorMstID : 85 },
        { proj : 1, modID : 4, editorMstID : 86 },
    ],
};

export default AppTemplate;